import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { find } from 'lodash';
import { fetchClients, fetchPages } from '../actions';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import Header from './header.jsx';
import Index from './index.jsx';
import Information from './information.jsx';
import Client from './client.jsx';

const firstChild = props => {
  const childrenArray = React.Children.toArray(props.children);
  return childrenArray[0] || null;
}

class App extends Component {
  constructor(props){
    super(props);

    this.state = {
      state: false
    }
  }
  componentWillMount(){
    this.props.fetchClients();
    this.props.fetchPages();
  }
  render() {
    const { clients, pages, location, loading } = this.props;
    const informationPage = find(pages, {'slug' : 'information' });

    if(clients.length == 0){
      return null;
    }

    console.log(this.state.state);
    return <div className={classNames('app', {loading: this.props.loading})}>
      <Header state={this.state.state} clients={clients}/>
      <TransitionGroup>
        <CSSTransition
          key={location.key}
          classNames="transition"
          timeout={400}
          appear={true}
          mountOnEnter={true}
          unmountOnExit={false}
          onEntering={() => this.setState({state: 'entering'})}
          onEntered={() => this.setState({state: 'entered'})}>

          <Switch location={location}>
            <Route exact path="/" render={() => <Index clients={clients} />} />
            <Route path="/information" render={() => <Information page={informationPage}/>} />
            <Route path="/client/:slug" render={() => <Client clients={clients} loading={loading}/>} />
          </Switch>
        </CSSTransition>
      </TransitionGroup>
    </div>;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    clients: state.clients,
    pages: state.pages,
    loading: state.loading
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchClients: () => {
      dispatch(fetchClients());
    },
    fetchPages: () => {
      dispatch(fetchPages());
    },
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
